module.exports = __webpack_public_path__ + "img/team-list3.9fa25717.png";